export default __webpack_public_path__ + "static/media/email-icon.e47764dc.svg";